import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../service/auth/auth.service';

declare var toastr: any;

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  loading = true;
  success = false;
  message = 'Please wait. Your password is being reset...';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    const token = this.route.snapshot.paramMap.get('token');

    if (!token) {
      this.loading = false;
      this.success = false;
      this.message = 'Invalid reset link.';
      this.redirectToLogin();
      return;
    }

    this.authService.resetPasswordByToken({ token: token }).subscribe(data => {
      this.loading = false;

      if (data.success) {
        this.success = true;
        this.message = 'Your password has been reset successfully. You will be redirected to the login page.';
        toastr.success('Password reset successfully.', '', { timeOut: 1500 });
      } else {
        this.success = false;
        this.message = data.error || 'Invalid or expired reset link.';
        toastr.error(this.message, '', { timeOut: 2000 });
      }

      this.redirectToLogin();

    }, error => {
      this.loading = false;
      this.success = false;
      this.message = 'Oops! Something went wrong.';
      toastr.error(this.message, '', { timeOut: 2000 });

      this.redirectToLogin();
    });
  }

  redirectToLogin() {
    setTimeout(() => {
      this.router.navigate(['/login']);
    }, 5000);
  }
}
